<section class="ssrk-stats-bar w-full max-w-full overflow-x-clip bg-ssrk-blue-primary" [attr.aria-label]="ariaLabel()">
  <div class="ssrk-stats-bar__grid grid min-w-0 grid-cols-2 md:grid-cols-4">
    @for (item of items(); track item.label) {
      <app-ssrk-card variant="stat" class="min-w-0">
        <div
          class="ssrk-stat-card__body min-w-0 text-center"
          [class.ssrk-stat-card__body--feature]="!!item.description"
        >
          <p
            class="ssrk-stat-card__value font-serif font-bold leading-none text-white"
            [class.ssrk-stat-card__value--compact]="item.valueSize === 'compact'"
            [class.ssrk-stat-card__value--icon]="item.valueSize === 'icon'"
            [attr.aria-hidden]="item.valueSize === 'icon' ? true : null"
          >
            {{ item.value }}
            @if (item.accent) {
              @if (item.accentPosition === 'inline') {
                <span class="text-ssrk-saffron-light"> {{ item.accent }}</span>
              } @else {
                <span class="text-ssrk-saffron-light">{{ item.accent }}</span>
              }
            }
          </p>
          <p
            class="ssrk-stat-card__label mt-1 break-words font-semibold tracking-wide"
            [class.ssrk-stat-card__label--feature]="!!item.description"
          >
            {{ item.label }}
          </p>
          @if (item.description) {
            <p class="ssrk-stat-card__description mt-1.5 break-words text-[12px] leading-snug text-white/75 sm:text-[12.5px]">
              {{ item.description }}
            </p>
          }
        </div>
      </app-ssrk-card>
    }
  </div>

  @if (footnote()) {
    <p class="ssrk-stats-bar__footnote border-t border-white/10 px-4 py-2.5 text-center text-[11px] leading-relaxed text-white/55 md:px-6 md:py-3 md:text-[11.5px]">
      {{ footnote() }}
    </p>
  }
</section>
